// Extra i18n strings for the new features (decoupled from the main i18n object).
export const ext = {
  ro: {
    account: "CONT", login: "INTRĂ", logout: "IEȘI", register: "CREEAZĂ CONT",
    myOrders: "COMENZILE MELE", noOrders: "Nu ai comenzi încă.", wishlist: "FAVORITE",
    search: "CAUTĂ", searchPh: "Caută produse…", track: "URMĂREȘTE COMANDA",
    trackPh: "Nr. comandă (ex. LN-…)", trackBtn: "CAUTĂ", noWish: "Nu ai produse favorite.",
    voucher: "COD REDUCERE", voucherApply: "APLICĂ", voucherOk: "Cod aplicat", voucherBad: "Cod invalid",
    discount: "REDUCERE", subscribed: "Te-ai abonat!", notifyTitle: "ANUNȚĂ-MĂ CÂND REVINE",
    notifyPh: "Email", notifyBtn: "ANUNȚĂ-MĂ", notifyOk: "Te vom anunța pe email.",
    name: "Nume", email: "Email", password: "Parolă", haveAccount: "Ai deja cont?",
    noAccount: "Nu ai cont?", zoom: "Mărește", about: "DESPRE", faq: "ÎNTREBĂRI",
    status: { received: "Primită", processing: "În procesare", shipped: "Expediată", delivered: "Livrată", cancelled: "Anulată" },
  },
  en: {
    account: "ACCOUNT", login: "LOG IN", logout: "LOG OUT", register: "CREATE ACCOUNT",
    myOrders: "MY ORDERS", noOrders: "You have no orders yet.", wishlist: "WISHLIST",
    search: "SEARCH", searchPh: "Search products…", track: "TRACK ORDER",
    trackPh: "Order no. (e.g. LN-…)", trackBtn: "TRACK", noWish: "No favourites yet.",
    voucher: "PROMO CODE", voucherApply: "APPLY", voucherOk: "Code applied", voucherBad: "Invalid code",
    discount: "DISCOUNT", subscribed: "Subscribed!", notifyTitle: "NOTIFY ME WHEN BACK",
    notifyPh: "Email", notifyBtn: "NOTIFY ME", notifyOk: "We'll email you.",
    name: "Name", email: "Email", password: "Password", haveAccount: "Already have an account?",
    noAccount: "No account?", zoom: "Zoom", about: "ABOUT", faq: "FAQ",
    status: { received: "Received", processing: "Processing", shipped: "Shipped", delivered: "Delivered", cancelled: "Cancelled" },
  },
};
